import React, { useEffect, useRef } from 'react';
import { Trans } from 'react-i18next';
import { IConfirmModalProps } from '../../../interfaces/interfaces';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';
import randomId from '../../../utils/randomId';
import Link from '../Link/Link';

function FavouriteListModal(props: IConfirmModalProps): JSX.Element {
  const modalRef = useRef<HTMLAnchorElement>(null);
  const { onAbort, list } = props;
  useEffect(() => {
    modalRef.current?.focus();
  }, []);
  const onAbortClick = () => {
    // close modal
    onAbort();
  };

  const modalContent = (
    <>
      <ul className="list">
        {list?.map((item) => (
          <li key={randomId('favourite-list')}>
            <Link
              linkHref={item.linkHref}
              linkText={item.linkText}
              linkClass={`link ic-arrowRight ${item.linkClass}`}
            />
          </li>
        ))}
      </ul>
    </>
  );

  return (
    <>
      <div className="modal favourite-list-modal" role="dialog">
        <div className="modal-inner l-container">
          <a
            role="button"
            className="modal-closer"
            onClick={onAbortClick}
            onKeyDown={(e) => {
              keyboardTriggerBasic(e, onAbortClick);
            }}
            tabIndex={0}
          >
            <span className="ic-close" />
          </a>

          <div className="modal-inner-content">
            <h3 className="hl-3">
              <Trans i18nKey="cockpit.favourite.modalHeadline">Favoritenübersicht</Trans>
            </h3>
            <div className="scrollable-content">{modalContent}</div>
          </div>
        </div>
      </div>
    </>
  );
}
export default FavouriteListModal;
